import React from "react"
import { inject, observer } from "mobx-react"
import { NextSeo } from "next-seo"
import TrafficSubmissionFlow from "~/pages/traffic-tickets/flow"

const WashingtonTrafficTicketsPage = () => {
  return (
    <>
      <NextSeo
        title="Washington Traffic Tickets | WinIt"
        description="Washington State enforces strict distracted driving laws, with common violations including failure to yield and speeding. Utilize the WinIt app to challenge your Washington traffic tickets with the help of qualified local lawyers."
        canonical="https://www.appwinit.com/washington-traffic-tickets"
        additionalMetaTags={[
          {
            property: "description",
            content:
              "Washington State enforces strict distracted driving laws, with common violations including failure to yield and speeding. Utilize the WinIt app to challenge your Washington traffic tickets with the help of qualified local lawyers.",
          },
        ]}
      />
      <TrafficSubmissionFlow />
    </>
  )
}

export default inject((all) => ({
  selectedState: all.store.trafficSubmission.selectedState,
}))(observer(WashingtonTrafficTicketsPage))
